import React, { useEffect, useRef, useState } from "react";
import HeaderSky from "./HeaderSky";
import Setting from "./Setting";
import BottomNavigation from "./BottomNavigation";
import SearchWrapper from "./SearchWrapper";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../context/BetSlipContext";
import OpenBets from "./OpenBets";
import { useLocation } from "react-router-dom";
import CasinoModal from "./CasinoModal";

const SkyLayout = ({ children }) => {
  const [setting, setSetting] = useState(false);
  const search = useContextSelector(AuthContext, (ctx) => {
    return ctx.search;
  });
  const setSearch = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSearch;
  });

  const showBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.showBets;
  });
  const casinoModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.casinoModal;
  });
  const setShowBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowBets;
  });
  const betLoaderAuth = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betLoader;
  });
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500); // adjust duration

    return () => clearTimeout(timer);
  }, [location]); // ⚡ use location.key instead of pathname
  return (
    <div className="ui-page ui-page-theme-a ui-page-active">
      <HeaderSky setSetting={setSetting} />
      {search && <SearchWrapper setSearch={setSearch} search={search} />}
      {setting && <Setting setSetting={setSetting} setting={setting} />}{" "}
      {showBets && <OpenBets setShowBets={setShowBets} showBets={showBets} />}
      {children}
      {(loading || betLoaderAuth) && (
        <div className="loading-overlay" id="loading">
          <div className="loading-wrap" style={{ display: "flex" }}>
            <div className="loading">
              <div />
              <div />
            </div>
            <p>Loading...</p>
          </div>
        </div>
      )}
      <BottomNavigation />
      {casinoModal && <CasinoModal />}
    </div>
  );
};

export default SkyLayout;
